import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "./Reveal";

const faqs = [
  {
    q: "Que requisitos preciso para a Formação Inicial TVDE?",
    a: "Precisas de Cartão de Cidadão ou Título de Residência, carta de condução portuguesa há mais de 3 anos, morada completa, contactos e a matrícula do carro a utilizar na componente prática. É ainda exigido o exame médico do Grupo 2.",
  },
  {
    q: "O valor do exame está incluído no preço?",
    a: "Sim. Tanto na Formação Inicial (155€) como na Renovação (67.50€), o valor do exame já está incluído — sem custos escondidos.",
  },
  {
    q: "A formação é online ou presencial?",
    a: "A Formação Inicial de 50 horas decorre em regime B-learning (online + componente prática). A Renovação de 8 horas pode ser feita presencialmente ou em e-learning.",
  },
  {
    q: "Preciso de ter carro próprio para conduzir na Bolt?",
    a: "Não é obrigatório. Após a certificação, a equipa do Grupo IFT explica-te as opções disponíveis, incluindo viatura própria ou integração em frota.",
  },
  {
    q: "Como começo a conduzir na Bolt depois do curso?",
    a: "Depois de obteres o certificado CMTVDE, o Grupo IFT acompanha-te no processo de registo e ativação na plataforma Bolt, até estares pronto para a estrada.",
  },
];

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="mx-auto max-w-4xl px-5 pb-28 sm:px-8 sm:pb-36">
      <Reveal>
        <p className="font-mono-x text-xs uppercase tracking-[0.35em] text-[#34d186]">FAQ</p>
        <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-[#171717] sm:text-3xl lg:text-4xl" data-testid="faq-title">
          Perguntas frequentes
        </h2>
      </Reveal>

      <div className="mt-12 divide-y divide-black/10 border-y border-black/10">
        {faqs.map((f, i) => (
          <Reveal key={f.q} delay={i * 0.06}>
            <div>
              <button
                data-testid={`faq-question-${i}`}
                onClick={() => setOpen(open === i ? -1 : i)}
                className="flex w-full items-center justify-between gap-6 py-6 text-left"
              >
                <span className={`font-display text-base font-bold transition-colors duration-300 sm:text-lg ${open === i ? "text-[#34d186]" : "text-[#171717]"}`}>
                  {f.q}
                </span>
                <motion.span animate={{ rotate: open === i ? 45 : 0 }} transition={{ duration: 0.3 }}>
                  <Plus size={20} className="shrink-0 text-[#34d186]" />
                </motion.span>
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                    className="overflow-hidden"
                  >
                    <p className="pb-7 pr-10 text-sm leading-relaxed text-[#737373] sm:text-base" data-testid={`faq-answer-${i}`}>
                      {f.a}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
